import { Component } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-eventdetail',
  templateUrl: './eventdetail.component.html',
  styleUrl: './eventdetail.component.css'
})
export class EventdetailComponent {

  iaevent: FormGroup;
  isSubmitted = false;

  UniqueEventId: any;
  action: any;

  data: any=[];
  trainerData: any=[];
  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router) {

    this.iaevent = this.formBuilder.group({
      status: new FormControl({ value: '', disabled: true }, Validators.required),
      remarks: new FormControl({ value: '', disabled: true }),
    });

    this.route.params.subscribe(params => {
      this.UniqueEventId = params['eventid'];
      if (params['action'] == 'update') {
        this.action = true;
        this.iaevent.get('status')?.enable();
        this.iaevent.get('remarks')?.enable();
      }

      this.LoadDetails(this.UniqueEventId);
    });
  }

  LoadDetails(eventId: string) {

    this.apiService.getRequest(API_ENDPOINTS.IA.GETIAEventDetail, { UniqueEventId: eventId }).subscribe(
      result => {
        if (result.status) {
          //this.msmeInsterestList = result.data.item2;
          this.data = result.data.item1;
          this.trainerData = result.data.item2;
          //if (result.data.item1['isWhatsAppEnabled']) {
          //  this.setCheckboxValues(true);
          //} else {
          //  this.setCheckboxValues(false);
          //}
        }
      }
    )
  }

  onSubmit() {
    if (this.iaevent.valid) {
      var formData = {

      };
      this.apiService.postRequest(API_ENDPOINTS.IA.POSTEVENTUPDATE, formData,).subscribe(
        res => {
          if (res.status) {
            this.toastr.success(res.message);
            this.router.navigate(['/msmeverification']);

          }
          else {
            this.toastr.error(res.message);
            this.router.navigate(['/msmeverification']);
          }
        }
      );
    }
  }

  back() {
    this.router.navigate(['/view_event']);
  }

}
